import type { ProjectRepository } from '../repository/ProjectRepository';
import type { ProjectGetCommand, ProjectItem } from '../entity/ProjectTypes';

export class GetProjectUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectGetCommand): Promise<ProjectItem> {
    return this.repository.getProject(command);
  }
}


